<div class="tabs-container">
  <div
    class="tabs-container__header disk-top-display"
    style="display: flex; justify-content: space-between"
  >
    <div class="tabs-container__header-title">
      <svg
        *ngIf="translate.currentLang == 'en'"
        width="24"
        height="24"
        style="cursor: pointer; transform: rotate(180deg)"
        routerLink="/tickets/my-tickets"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.4301 18.82C14.2401 18.82 14.0501 18.75 13.9001 18.6C13.6101 18.31 13.6101 17.83 13.9001 17.54L19.4401 12L13.9001 6.46C13.6101 6.17 13.6101 5.69 13.9001 5.4C14.1901 5.11 14.6701 5.11 14.9601 5.4L21.0301 11.47C21.3201 11.76 21.3201 12.24 21.0301 12.53L14.9601 18.6C14.8101 18.75 14.6201 18.82 14.4301 18.82Z"
          fill="#6C757D"
        />
        <path
          d="M20.33 12.75H3.5C3.09 12.75 2.75 12.41 2.75 12C2.75 11.59 3.09 11.25 3.5 11.25H20.33C20.74 11.25 21.08 11.59 21.08 12C21.08 12.41 20.74 12.75 20.33 12.75Z"
          fill="#6C757D"
        />
      </svg>
      <svg
        *ngIf="translate.currentLang == 'ar'"
        width="24"
        height="24"
        style="cursor: pointer"
        routerLink="/tickets/my-tickets"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.4301 18.82C14.2401 18.82 14.0501 18.75 13.9001 18.6C13.6101 18.31 13.6101 17.83 13.9001 17.54L19.4401 12L13.9001 6.46C13.6101 6.17 13.6101 5.69 13.9001 5.4C14.1901 5.11 14.6701 5.11 14.9601 5.4L21.0301 11.47C21.3201 11.76 21.3201 12.24 21.0301 12.53L14.9601 18.6C14.8101 18.75 14.6201 18.82 14.4301 18.82Z"
          fill="#6C757D"
        />
        <path
          d="M20.33 12.75H3.5C3.09 12.75 2.75 12.41 2.75 12C2.75 11.59 3.09 11.25 3.5 11.25H20.33C20.74 11.25 21.08 11.59 21.08 12C21.08 12.41 20.74 12.75 20.33 12.75Z"
          fill="#6C757D"
        />
      </svg>
      <h2>{{ "Sport.TransferredToYou" | translate }}</h2>
    </div>
    <div class="tabs-container__header-form">
      <div class="filter">
        <form [formGroup]="filterForm">
          <ng-select
            (change)="onFilterChange()"
            formControlName="championId"
            [clearable]="false"
            [searchable]="false"
          >
            <ng-container>
              <ng-option value="">
                {{ "AllChampions" | translate }}
              </ng-option>
              <ng-option
                value=""
                *ngFor="let champion of champions"
                [value]="champion.id"
              >
                {{ helpers.getElementTranslatedName(champion) }}
              </ng-option>
            </ng-container>
          </ng-select>
        </form>
      </div>
      <div class="tabs-container__togggle">
        <div class="form-check form-group select-all">
          <input
            [disabled]="!ticketsData?.data?.length"
            class="form-check-input"
            type="checkbox"
            [style.background-color]="selectAll ? teamColor : ''"
            [style.border-color]="selectAll ? teamColor : ''"
            (change)="toggleSelectAll()"
            [checked]="ticketsData?.data?.length && selectAll"
          />
          <label
            class="form-check-label"
            [style.color]="selectAll ? teamColor : ''"
          >
            {{ "Sport.SelectAll" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
  <!-- ----mobileView -->
  <div class="tabs-container__mobile-header mobile-display">
    <div class="tabs-container__mobile-header__manage">
      <div class="tabs-container__header-title">
        <div>{{ "Sport.TransferredToYou" | translate }}</div>
      </div>
      <div class="tabs-container__header-form">
        <div class="tabs-container__togggle">
          <div class="form-check form-group select-all">
            <input
              [disabled]="!ticketsData?.data?.length"
              class="form-check-input"
              type="checkbox"
              [style.background-color]="selectAll ? teamColor : ''"
              [style.border-color]="selectAll ? teamColor : ''"
              (change)="toggleSelectAll()"
              [checked]="ticketsData?.data?.length && selectAll"
            />
            <label
              class="form-check-label"
              [style.color]="selectAll ? teamColor : ''"
            >
              {{ "Sport.SelectAll" | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <form [formGroup]="filterForm">
        <ng-select
          (change)="onFilterChange()"
          formControlName="championId"
          [clearable]="false"
          [searchable]="false"
        >
          <ng-container>
            <ng-option value="">
              {{ "AllChampions" | translate }}
            </ng-option>
            <ng-option
              value=""
              *ngFor="let champion of champions"
              [value]="champion.id"
            >
              {{ helpers.getElementTranslatedName(champion) }}
            </ng-option>
          </ng-container>
        </ng-select>
      </form>
    </div>
    <!-- <div
        class="tabs-container__header-mobile__selects"
        [ngClass]="{ 'hide-mobile':  isMobileView }"
      >
        <form [formGroup]="form">
          <div class="tabs-container__header-form">
            <div class="form-group select">
              <ng-select
                (change)="onFilterChange()"
                formControlName="champion"
                placeholder="{{ 'Tickets.Champions' | translate }}"
                [clearable]="false"
              >
                <ng-option value="">
                  {{ "Tickets.AllChampions" | translate }}
                </ng-option>
                <ng-option
                  *ngFor="let champion of champions || []"
                  [value]="champion"
                >
                  {{
                    translate.currentLang == "ar"
                      ? champion.nameAr
                      : champion.nameEn
                  }}
                </ng-option>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    {{ "Matches.NoData" | translate }}
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </form>
      </div> -->
    <div
      class="transfer-header__action"
      *ngIf="
        ticketsData?.data?.length && (selectedTicketsIds?.length || selectAll)
      "
    >
      <button
        app-click-stop-propagation
        class="success-btn"
        (click)="acceptTickets()"
      >
        <div style="display: flex; gap: 5px">
          <svg
            style="width: 24px"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.31987 10.6629L2.25122 7.59421L3.01838 6.82704L5.31987 9.12853L10.2593 4.18909L11.0265 4.95625L5.31987 10.6629Z"
              fill="white"
            />
          </svg>
          <span style="align-content: center">
            {{ "Sport.AcceptTickets" | translate }}
          </span>
        </div>
      </button>
    </div>
  </div>
  <div
    class="transfer-header__action disk-top-display"
    *ngIf="
      ticketsData?.data?.length && (selectedTicketsIds?.length || selectAll)
    "
  >
    <button
      app-click-stop-propagation
      class="success-btn"
      style="padding: 17px 24px"
      (click)="acceptTickets()"
    >
      <div style="display: flex; gap: 5px">
        <svg
          style="width: 24px"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.31987 10.6629L2.25122 7.59421L3.01838 6.82704L5.31987 9.12853L10.2593 4.18909L11.0265 4.95625L5.31987 10.6629Z"
            fill="white"
          />
        </svg>
        <span style="align-content: center">
          {{ "Sport.AcceptTickets" | translate }}
        </span>
      </div>
    </button>
  </div>

  <div class="tickets mt-3">
    <div *ngIf="tickets; else loader">
      <div *ngIf="tickets.length; else noData">
        <div *ngFor="let ticket of tickets">
          <div class="ticket-row">
            <div class="select-one">
              <input
                class="form-check-input"
                type="checkbox"
                [style.background-color]="ticket.isChecked ? teamColor : ''"
                [style.border-color]="ticket.isChecked ? teamColor : ''"
                (change)="toggleCheckbox(ticket)"
                [checked]="ticket.isChecked"
              />
            </div>
            <div
              class="ticket-card"
              [style.border]="ticket.isChecked ? '1px solid ' + teamColor : ''"
            >
              <div class="row disk-top-display">
                <div class="ticket-card__item col-md-5">
                  <div class="match-data borderd">
                    <div class="match-card">
                      <div>
                        <img src="{{ ticket.teamHomeLogo }}" />
                        <div class="mt-2">
                          <div *ngIf="translate.currentLang === 'ar'">
                            {{ ticket.teamHomeNameAr }}
                          </div>
                          <div *ngIf="translate.currentLang === 'en'">
                            {{ ticket.teamHomeNameEn }}
                          </div>
                        </div>
                      </div>

                      <span class="black-box">
                        {{ ticket.matchDate | date }} |
                        {{ ticket.matchTime }}
                      </span>
                      <div>
                        <img src="{{ ticket.teamAwayLogo }}" />
                        <div class="mt-2">
                          <div *ngIf="translate.currentLang === 'ar'">
                            {{ ticket.teamAwayNameAr }}
                          </div>
                          <div *ngIf="translate.currentLang === 'en'">
                            {{ ticket.teamAwayNameEn }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ticket-card__item col-md-3">
                  <div class="borderd">
                    <div class="ticket-card__item-label">
                      {{ "Sport.BuyersDetails" | translate }}
                    </div>

                    <div class="ticket-card__item-content">
                      {{ ticket.buyerName }}
                    </div>
                  </div>
                </div>
                <div class="ticket-card__item col-sm-5 col-md-2">
                  <div class="ticket-card__item-label">
                    {{ "Mobile number" | translate }}
                  </div>

                  <div class="ticket-card__item-content">
                    <span *ngIf="translate.currentLang === 'en'">
                      {{ ticket.buyerMobile }}
                    </span>
                    <span *ngIf="translate.currentLang === 'ar'">
                      {{ helpers.returnMobileArabic(ticket.buyerMobile) }}
                    </span>
                  </div>
                </div>

                <div class="ticket-card__item col-sm-5 col-md-2">
                  <button
                    style="width: 140px"
                    app-click-stop-propagation
                    class="success-btn"
                    (click)="acceptTicket([ticket.transferOrderId])"
                  >
                    <div style="display: flex; gap: 5px">
                      <svg
                        style="width: 24px"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.31987 10.6629L2.25122 7.59421L3.01838 6.82704L5.31987 9.12853L10.2593 4.18909L11.0265 4.95625L5.31987 10.6629Z"
                          fill="white"
                        />
                      </svg>
                      <span style="align-content: center">
                        {{ "Sport.AcceptTicket" | translate }}
                      </span>
                    </div>
                  </button>
                </div>
              </div>
              <div class="mobile-card mobile-display">
                <div class="match-card">
                  <img src="{{ ticket.teamHomeLogo }}" />

                  <span class="black-box">
                    {{ ticket.matchDate | date }} |
                    {{ ticket.matchTime }}
                  </span>
                  <img src="{{ ticket.teamAwayLogo }}" />
                </div>
                <div class="mobile-card__details">
                  <div class="mobile-card__details-buyer">
                    <div>
                      <div class="mobile-card__details-label">
                        {{ "Sport.BuyersDetails" | translate }}
                      </div>

                      <div class="mobile-card__details-content">
                        {{ ticket.buyerName }}
                      </div>
                    </div>

                    <div>
                      <div class="mobile-card__details-label">
                        {{ "Mobile number" | translate }}
                      </div>

                      <div class="mobile-card__details-content">
                        <span *ngIf="translate.currentLang === 'en'">
                          {{ ticket.buyerMobile }}
                        </span>
                        <span *ngIf="translate.currentLang === 'ar'">
                          {{ helpers.returnMobileArabic(ticket.buyerMobile) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="mobile-card__details-btn">
                    <button
                      style="width: -webkit-fill-available"
                      app-click-stop-propagation
                      class="success-btn"
                      (click)="acceptTicket([ticket.transferOrderId])"
                    >
                      <div style="display: flex; gap: 5px">
                        <svg
                          style="width: 24px"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.31987 10.6629L2.25122 7.59421L3.01838 6.82704L5.31987 9.12853L10.2593 4.18909L11.0265 4.95625L5.31987 10.6629Z"
                            fill="white"
                          />
                        </svg>
                        <span style="align-content: center">
                          {{ "Sport.AcceptTicket" | translate }}
                        </span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-pagination
          *ngIf="ticketsMeta"
          [meta]="ticketsMeta"
          (goPage)="goToPage($event)"
          (goNext)="onNext()"
          (goPrev)="onPrev()"
        >
        </app-pagination>
      </div>
    </div>
  </div>

  <ng-template #noData>
    <app-nodata
      title="{{ 'No Tickets Transferred' | translate }}"
      [img]="'assets/images/tickets/no-ticket.png'"
      link=""
    ></app-nodata>
  </ng-template>

  <ng-template #loader>
    <app-loading></app-loading>
  </ng-template>

  <!-- <div class="tab-content-group">
      <ng-container *ngFor="let tab of tabs">
        <div class="tab-content" *ngIf="tab.active">
  
  
   
        </div>
      </ng-container>
    </div> -->
</div>
